import { ToastOptions, toast } from 'react-toastify';
import IconCheckCircle from 'src/presentations/components/atom/icons/CheckCircle';
import IconExclamationCircle from 'src/presentations/components/atom/icons/ExclamationCircle';
import IconInfoCircle from 'src/presentations/components/atom/icons/InfoCircle';
import CloseIcon from '@mui/icons-material/Close';
import { featureFlags } from 'src/config/featureFlags';
import { InternalAxiosRequestConfig } from 'axios';

import { ToastProps } from './types';

export const openToastError = <T extends Error>(error: T, requestConfig?: InternalAxiosRequestConfig) => {
  const isShowErrorDetail = featureFlags.SHOW_SERVER_ERROR_DETAIL;
  let message = error.message?.toString() ?? '';
  if (message.startsWith('Server could not handle the request') && requestConfig && isShowErrorDetail) {
    message = `${requestConfig?.method?.toUpperCase()} ${requestConfig?.url}: ${message}`;
  }
  openToast({
    title: 'Error',
    description: message,
    toastType: 'error',
    toastOptions: { toastId: message },
  });
};

// Types moved to types.ts

export const getDefaultToastOptions = (toastOptions?: ToastOptions): ToastOptions => ({
  ...toastOptions,
  autoClose: 7000,
  closeOnClick: true,
  draggable: false,
  hideProgressBar: true,
  pauseOnHover: false,
  position: 'bottom-left',
  closeButton: <CloseIcon style={{ width: '20px' }} />,
  icon: ({ type }) => {
    const size = 24;
    switch (type) {
      case 'success':
        return <IconCheckCircle size={size} />;
      case 'error':
      case 'warning':
        return <IconExclamationCircle size={size} />;
      default:
        return <IconInfoCircle color='white' size={size} />;
    }
  },
});

export const openToast = ({ toastType = 'info', title, description, toastOptions }: ToastProps) => {
  toast[toastType](
    <div className='w-fit'>
      <p className='text-14'>{title}</p>
      {description && <p className='text-12 text-grey-40 '>{description}</p>}
    </div>,
    getDefaultToastOptions(toastOptions)
  );
};

function useToast() {
  return openToast;
}

export default useToast;
